module.exports = __webpack_public_path__ + "img/cell.png";